export default [
  {
    path: '/history-tracking',
    name: 'history-tracking',
    meta: { requiresAuth: true },
    component: () => import('@/pages/history-tracking/index.vue')
  }
]
